import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import {LandingService} from '../landing.service'

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  animations: [
    trigger('test', [
      // ...
      transition (':enter', [
        style({opacity: 0, marginBottom : '-50vh'}),
        animate ('1s ease-in-out',
          style ({ opacity: '1', marginBottom: '*' }),
        ),
      ]),
      transition (':leave', [
        animate ('1s ease',
          style ({marginLeft: '-50vw', marginTop: '-50vh',  transform:"scale(0.3)", opacity: 0}),
        ),
      ]),
    ]),
  ],
})
export class LandingPageComponent implements OnInit {

  loaded = false
  content = false;

  constructor(public landingService: LandingService) { }

  ngOnInit() {
    this.landingService.updateLocation('Home');
    setTimeout(() => {
      this.loaded = true;
    }, 100)
  }

  nextpage(){
    this.loaded = false;
    this.landingService.showLogo();
    setTimeout(()=> {
      this.content = true;
    },1000)
  }

}
